import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';
import { colors, neumorphism } from './constant';
import { respondTo } from './responsive';

const TabSwitcher = ({ className, options = [], value = 0, setValue }) => {

    const indicatorRef = useRef(null);
    const rootRef = useRef(null);

    const onOptionClick = index => {
        setValue?.(index);
    }

    useEffect(() => {
        const targetDom = [...rootRef.current.querySelectorAll('button')]?.[value];
        const left = targetDom?.offsetLeft || 0;
        const width = targetDom?.getBoundingClientRect()?.width;

        indicatorRef.current.style.left = `${left}px`;
        indicatorRef.current.style.width = `${width - 8}px`;
    }, [value])

    return (
        <RootSpan className={className} ref={rootRef}>

            <Indicator ref={indicatorRef}/>

            { options.map((item, index) =>
                <Item key={index} onClick={() => onOptionClick(index)}>{ item }</Item>
            )}

        </RootSpan>
    )
}

const RootSpan = styled.span`
    display: inline-block;
    border-radius: 50em;
    background-color: ${ colors.bgButtonPressed };
    position: relative;

    ${ neumorphism.concave };

    ${ respondTo.md } {
        width: 100%;
        margin-right: 0 !important;
        display: inline-flex;
    }
`

const Item = styled.button`
    display: inline-block;
    padding: 10px 24px;
    min-width: 160px;
    outline: none;
    border: 0;

    position: relative;
    z-index: 1;

    background-color: transparent;

    font-size: 16px;
    text-align: center;
    color: ${ colors.text };

    ${ respondTo.md } {
        min-width: 0;
        flex: 1;
        font-size: 12px;
        padding: 6px 16px;
    }
`

const Indicator = styled.div`
    position: absolute;
    box-sizing: border-box;
    margin: 4px;
    border-radius: 50em;

    min-width: calc(120px - 8px);
    height: calc(100% - 8px);
    background-color: ${ colors.bgDepth1 };
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

    transition: left .2s, width .2s;
`

export default TabSwitcher;
